export default __webpack_public_path__ + "static/media/Green0004.752ca945.png";